let $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}

export { $bdb11010cef70236$export$cd8c9cb68f842629 as $ };
//# sourceMappingURL=useId-CSSKCXgy.js.map
